export default __webpack_public_path__ + "static/media/tt3.ffb1f71b.png";